<template>

    <div class="content-table-box">

        <div class="table-row" v-for="(item,index) in discussData" :key="item.id + '-' + index">
            <div class="comment-section">
                <div class="comment-title">
                    <div class="title-left">
                        <span class="ks-info">{{ item.departmentName }}</span>
<!--
                        <span class="noun-type">{{ item.categoryName }}</span>
-->
                        <span class="term-chinese" @click="redirectTo(item.terminologyId)">{{ item.terminologyName }}</span>
                        <span class="comment-tag">{{ item.tag }}</span>
                    </div>
                    <p class="title-right">{{ item.createTime | formatDateTime }}</p>
                </div>
                <div class="comment-content">
                    <p>
                        {{ item.content }}
                    </p>
                </div>
                <div class="comment-footer">
                    <div class="footer-left">
                        <img src="@/assets/img/avatar.png" alt="">
                        <span class="observer"> {{ item.username }}</span>
                        <span class="last-reply-desc">最后回复</span>
                        <span class="last-reply-datetime">{{(item.lastRelayTime ? item.lastRelayTime : item.createTime) | formatDate }}</span>
                    </div>
                    <div class="footer-right" @click="handleShowReplyList(index)">
                        <i class="el-icon-chat-line-round"></i>
                        <span class="comment-reply">回复<span v-if="item.relayCount!==0">（{{ item.relayCount }}）</span></span>
                    </div>
                </div>
            </div>
            <div class="reply-section" :class="'reply-section-id-'+item.id" v-show="false">
                <div class="reply-content">
                    <div class="reply-first-line">
                        <div class="reply-info" >
                            <div tabindex="0" :id="item.id" contenteditable="true" spellcheck="false" :placeholder="'回复@'+item.username+':'"  @input="onDivInput($event,item)"   class="reply-input reply-comment-input"></div>
                        </div>
                        <div class="reply-btn-box">
                            <el-button class="reply-btn" type="primary" @click="sendCommentReply(item,index)" :disabled="item.disabled || btnDisabled">发送</el-button>
                        </div>
                    </div>
                    <div class="reply-list-box">
                        <div class="reply-list" v-for="(subItem,subIndex) in item.comments" :key="subItem.id + '-' +subIndex">
                            <div class="reply-item">
                                <div class="reply-item-left">
                                    <img src="@/assets/img/avatar.png" alt="">
                                </div>
                                <div class="reply-item-right">
                                    <div class="item-right-first-line">
                                        <span class="item-replier">{{ subItem.username }}</span>
                                        <span class="item-desc">回复</span>
                                        <span class="item-observer">{{ subItem.relayToUserName }}：</span>
                                        <span class="item-reply-content">
                                          {{ subItem.content }}
                                        </span>
                                    </div>
                                    <div class="item-right-second-line">
                                        <p class="item-reply-datetime">{{ subItem.createTime | formatDate}}</p>
                                        <p class="item-reply-link" @click="handleShowReply(subItem.id)">回复</p>
                                    </div>
                                </div>
                            </div>
                            <div class="reply-input-line" :class="'reply-input-id-'+subItem.id" v-show="false">
                                <div class="reply-info" >
                                    <div tabindex="0" :id="subItem.id" contenteditable="true" spellcheck="false" :placeholder="'回复@'+subItem.username+':'"   @input="onDivInput($event,subItem)"  class="reply-input reply-comment-input"></div>
                                </div>
                                <div class="reply-btn-box">
                                    <el-button class="reply-btn" type="primary" @click="sendCommentReply(subItem,index)" :disabled="subItem.disabled || btnDisabled" >发送</el-button>
                                </div>
                            </div>
                            <div v-for="(threeItem,threeIndex) in subItem.children" :key="threeItem.id+ '-' +threeIndex">
                                <div class="reply-item" style="padding-left: 50px"  >
                                    <div class="reply-item-left">
                                        <img src="@/assets/img/avatar.png" alt="">
                                    </div>
                                    <div class="reply-item-right">
                                        <div class="item-right-first-line">
                                            <span class="item-replier">{{ threeItem.username }}</span>
                                            <span class="item-desc">回复</span>
                                            <span class="item-observer">{{ threeItem.relayToUserName }}：</span>
                                            <span class="item-reply-content">
                                           {{ threeItem.content }}
                                        </span>
                                        </div>
                                        <div class="item-right-second-line">
                                            <p class="item-reply-datetime">{{ threeItem.createTime | formatDate}}</p>
                                            <p class="item-reply-link" @click="handleShowReply(threeItem.id)">回复</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="reply-input-line" :class="'reply-input-id-'+threeItem.id" v-show="false">
                                    <div class="reply-info" >
                                        <div tabindex="0" :id="threeItem.id" contenteditable="true" spellcheck="false" :placeholder="'回复@'+threeItem.username+':'"  @input="onDivInput($event,threeItem)"   class="reply-input reply-comment-input"></div>
                                    </div>
                                    <div class="reply-btn-box">
                                        <el-button class="reply-btn" type="primary" @click="sendCommentReply(threeItem,index)" :disabled="threeItem.disabled || btnDisabled">发送</el-button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
<!--
                    <div class="fetch-more-reply" @click="handleFetchMoreReplys(index)" v-if="item.totalPageCount>1"><span>加载更多</span> </div>
-->
                </div>
            </div>
        </div>
        <div class="tip"
             v-if="discussData.length==0"
            >
            <div>
                <img src="../../../assets/img/defaultForum.png" alt="">
            </div>
            <p v-if="menuIndex === 0">暂无关注内容</p>
            <p v-else>暂无相关评论</p>
        </div>

    </div>

</template>

<script>
    import dateLib from "@/lib/dateLib";
    import $ from 'jquery';
    import discussApi from '@/api/discussion';
    import {po_Last_Div} from '@/lib/utils'

    export default {
        name: 'ForumContent',
        props: {
            discussData: {
                type: Array,
                default: () => {
                    return [];
                },
            },

            menuIndex: {
                type: Number,
            },
        },
        data() {

            return {
                // discussData:[],
                replyPageInfo:{
                    pageIndex:1,
                    pageSize:10,
                },
                btnDisabled: false,
            };
        },
        filters: {
            formatDate(time) {
                return  time && time.substring(0,16)
            },
            formatDateTime(time){
                return dateLib.dateStrForma(time,'YYYY-MM-DD HH:mm:ss','YYYY年MM月DD日 HH:mm')
            }
        },
        methods: {
            redirectTo(id){
                const routerPath = '/terminology/'+id
                this.$router.push({
                    path:routerPath,
                    query:{
                        t: +new Date()
                    }
                })
            },
            onDivInput(e,item){
                let content = e.target.innerText;
                if(content!=='') {
                    item.disabled = false;
                }else {
                    item.disabled = true;
                }
                if(content.length>200){
                    e.target.innerText = content.substring(0, 200);
                    this.$message.warning('回复内容最多允许输入200个字')
                    let el = document.getElementById(e.target.id);
                    po_Last_Div(el)
                    return false;
                }


            },
            async handleFetchMoreReplys(i){
                //加载更多的时候 pageSize翻倍 ，totalPageCount>1，加载按钮就显示
                let obj = Object.assign({},this.discussData[i]);
                // obj.pageSize*2
                let res = await discussApi.getDiscReplyList (obj.id, this.replyPageInfo.pageIndex, null);
                let data  =  res.data.map(item=>{
                    item.disabled = true;
                    return item;
                })
                let replyList = this.translateDataToTree(data,obj.id)
                obj.comments = replyList;
                obj.disabled = true;
                obj.pageSize = res.pageSize;
                obj.totalPageCount = res.totalPageCount;
                this.discussData.splice(i,1,obj)
            },
            async handleShowReply(id){
                $('.reply-input-id-'+id).toggle(500)
            },
            async reloadReplyList(i){
                let obj = Object.assign({},this.discussData[i]);
                // obj.pageSize
                let res = await discussApi.getDiscReplyList (obj.id, this.replyPageInfo.pageIndex, null);
                /*let data  =  res.data.map(item=>{
                    item.disabled = true;
                    return item;
                })*/
                let replyList = this.translateDataToTree(res.data, obj.id)
                console.log('replyList %o ', replyList);
                obj.comments = replyList;
                this.updateCommentItemState(obj);
                this.updateListItemState(obj.comments);
                obj.pageSize = res.pageSize;
                obj.totalPageCount = res.totalPageCount;
                this.discussData.splice(i,1,obj)
            },

            updateCommentItemState (commentItem) {
                if (!commentItem) {
                    return;
                }
                let commentInputDom =  document.getElementById(commentItem.id);
                if (commentInputDom) {
                    let content =  commentInputDom.innerText.trim().replace(/&nbsp;/g, '');
                    if (content && content !== '') {
                         commentItem.disabled = false;
                    } else {
                        commentItem.disabled = true;
                    }
                }
            },

            updateListItemState (list) {
                if (!list || list.length === 0) {
                    return;
                }
                list.forEach(item => {
                    if (!document.getElementById(item.id)) {
                        return;
                    }
                    let content =  document.getElementById(item.id).innerText ? document.getElementById(item.id).innerText.trim().replace(/&nbsp;/g, '') : '';
                    if (content !== '') {
                        item.disabled = false;
                    }
                    this.updateListItemState(item.children);
                });
            },

            async sendCommentReply(item,index){
                this.btnDisabled = true;
                let content =  document.getElementById(item.id).innerText.trim().replace(/&nbsp;/g, '');
                if(content===''){
                    this.$message.warning('请输入回复内容')
                    return ;
                }
                if(content.length>200){
                    this.$message.warning('回复内容最多允许输入200个字')
                    return ;
                }
                item.disabled = true;
                let res = await discussApi.addDiscReply (item.id, content);
                item.disabled = false;
                if(res){
                    this.$message.success('发送成功')
                    $('.reply-input-id-'+item.id).toggle(500)
                    document.getElementById(item.id).innerText = "";
                    this.$set(this.discussData[index],"relayCount", (this.discussData[index].relayCount+1))
                    //重新拉取评论数据
                    this.reloadReplyList(index)
                }
                this.btnDisabled = false;

            },

            /*buildArrToTree(arr, parentId) {
                let dataArr = JSON.parse(JSON.stringify(arr));
                let firstLevelArr = dataArr.filter(item => item.relayTo === parentId);
                let restArr = dataArr.filter(item => item.relayTo !== parentId);

                let pastRecord = {};
                let resultArr = firstLevelArr.map(item => {
                    item.children = [];
                    restArr.forEach(subItem => {
                        if (pastRecord[subItem.id]) {
                            return;
                        }
                        if (subItem.relayTo === item.id) {
                            pastRecord[subItem.id] = true;
                            item.children.push(subItem);
                        }
                    });
                    return item;
                });

                return resultArr;
            },*/

            translateDataToTree(dataArr,discussionId){
                let data = JSON.parse(JSON.stringify(dataArr));
                let iterator = (reverse) => {
                    let i = reverse && (data.length-1) || 0;
                    let hasNext = () => (i >= 0) && (i < data.length);
                    let next = () => data[reverse && (i--) || (i++)];
                    return {
                        hasNext, next
                    }
                };

                let relayMap = {};
                //遍历 找出第一层的relay
                let it = iterator(false);
                while (it.hasNext()) {
                    let v = it.next();
                    if (v.relayTo === discussionId) {
                        relayMap[v.id] = v;
                        v.level = 1;
                        v.children = [];
                    } else {
                        v.level = 2;
                        relayMap[v.relayTo].children.push(v);
                        relayMap[v.id] = relayMap[v.relayTo];
                    }
                }
                // 评论的回复按照时间倒序
                let resultArr = data.filter(v => v.relayTo === discussionId);
                // let resultArr = this.buildArrToTree(dataArr, discussionId);
                resultArr.sort(function (a, b) {
                    let aDate = +new Date(a.createTime);
                    let bDate = +new Date(b.createTime);
                    return aDate > bDate ? -1 : (aDate === bDate) ? 0 : 1;
                });
                // 回复的回复按照时间正序
                let newResultArr = resultArr.map(item => {
                    if (item && item.children && item.children.length > 0) {
                        item.children.sort(
                            function (a, b) {
                                let aDate = +new Date(a.createTime);
                                let bDate = +new Date(b.createTime);
                                return aDate > bDate ? 1 : (aDate === bDate) ? 0 : -1;
                            }
                        );
                    }
                    return item;
                });
                return newResultArr;

            },
            async handleShowReplyList(i){
                let obj = Object.assign({},this.discussData[i]);
                if(!(obj.comments && obj.comments.length>0 )){
                    //获取回复数据 this.replyPageInfo.pageSize
                    let res = await discussApi.getDiscReplyList (obj.id, this.replyPageInfo.pageIndex, null);
                    console.log(res);
                    // console.log(res)
                    let data  =  res.data.map(item=>{
                        item.disabled = true;
                        return item;
                    })
                    let replyList = this.translateDataToTree(data,obj.id)
                    obj.comments = replyList;
                    obj.disabled = true;//用于控制按钮的启用和禁用
                    obj.pageSize = res.pageSize;
                    obj.totalPageCount = res.totalPageCount;
                    this.discussData.splice(i,1,obj)
                }

                $('.reply-section-id-'+obj.id).toggle(500)

            },



        },

        created() {
        },

        mounted() {

        }
    }
</script>

<style lang="less" scoped>

    p {
        padding: 0;
        margin: 0;
    }

    .content-table-box {
        width: 100%;
        height: 100%;
        .tip {
            font-size: 14px;
            color: #969696;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;

            img {
                width: 110px;
                height: 100px;
            }

            p {
                padding: 10px 0;
                margin: 0;
            }
        }
        .table-row {

            .comment-section {
                padding-bottom: 10px;
                padding-right: 12px;
                border-bottom: 1px solid #D6D6D6;

                .comment-title {
                    height: 20px;
                    line-height: 20px;
                    padding: 10px 0;
                    display: flex;
                    justify-content: space-between;

                    .title-left {
                        .ks-info,
                        .term-chinese,
                        .comment-tag {
                            color: #F15B5B;
                            padding: 0 3px;
                        }

                        .ks-info,
                        .comment-tag {
                            color: #1DAABA;
                        }

                        .term-chinese {
                            cursor: pointer;
                        }

                        .term-chinese:before,
                        .term-chinese:after {
                            content: '#';
                            color: #F15B5B;
                        }

                        .ks-info:before,
                        .ks-info:after,
                        .comment-tag:before,
                        .comment-tag:after {
                            content: '#';
                            color: #1DAABA;
                        }

                    }

                    .title-right {
                        color: #999;
                        font-size: 12px;
                    }

                }

                .comment-content {
                    height: 60px;
                    p {
                        font-size: 12px;
                        line-height: 20px;
                        color: #373434;
                        word-break: break-all;
                    }
                }

                .comment-footer {
                    display: flex;
                    justify-content: space-between;
                    line-height: 28px;

                    .footer-left {
                        img {
                            width: 28px;
                            height: 28px;
                            border-radius: 50%;
                            vertical-align: middle;
                            display: inline-block;
                        }

                        span {
                            color: #AFAFAF;
                            font-size: 12px;
                        }

                        .observer {
                            padding: 0 10px;
                        }

                        .last-reply-datetime {
                            padding-left: 5px;
                        }
                    }

                    .footer-right {
                        font-size: 12px;
                        color: #1DAABA;
                    }

                    .footer-right:hover {
                        cursor: pointer;
                    }
                }

            }

            .reply-section {
                background-color: #F3F4F8;
                padding: 20px;

                .reply-content {

                    .reply-btn-box {
                        display: flex;
                        justify-content: flex-end;

                        .reply-btn {
                            width: 88px;
                            padding: 6px 20px;
                            margin: 16px 0 10px;
                        }
                    }

                    .reply-first-line,.reply-input-line {
                        .reply-info{
                            background-color: #fff;
                            border: 1px solid #1DAABA;
                            border-radius: 3px;
                            box-shadow: 0 0 0 1px #1DAABA;
                            box-sizing: content-box;
                            .reply-input{
                                line-height: 14px;
                                font-size: 12px;
                                font-weight:400;
                                padding: 8px 8px;
                                color: #333333FF;
                                background-color: #fff;
                                border-radius: 4px;
                                &:empty:before{
                                    content:attr(placeholder);
                                    opacity: .4;
                                    pointer-events: none;
                                    user-select: none;
                                }
                                &:focus:before{
                                    content:none
                                }
                                &:focus{
                                    /*padding: 7px 7px;*/
                                    /*border: 1px solid #1DAABA;*/
                                    box-shadow:none;
                                    outline:none;
                                }
                            }
                        }

                    }

                    .reply-list-box {

                        .reply-list {
                            .reply-item {
                                padding: 20px 0;
                                border-top: 1px solid #D6D6D6;
                                display: flex;

                                .reply-item-left {
                                    padding: 0 10px;
                                    img {
                                        width: 33px;
                                        height: 33px;
                                        border-radius: 50%;
                                        vertical-align: middle;
                                        display: inline-block;
                                    }
                                }

                                .reply-item-right {
                                    width: 100%;
                                    font-size: 12px;
                                    .item-right-first-line {

                                        span {
                                            line-height: 20px;
                                        }

                                        .item-replier,
                                        .item-observer {
                                            color: #2B66BA;
                                        }

                                        .item-desc {
                                            color: #969696;
                                            padding: 0 5px;
                                        }

                                        .item-reply-content {
                                            word-break: break-all;
                                        }

                                    }

                                    .item-right-second-line {
                                        display: flex;
                                        justify-content: space-between;
                                        padding-top: 5px;

                                        .item-reply-datetime {
                                            color: #969696;
                                        }
                                        .item-reply-link{
                                            color: #424242;
                                            font-weight:400;
                                            cursor: pointer;
                                        }
                                    }

                                }
                            }

                            .reply-input-line {
                                border-top: 1px solid #DCDCDC;
                                padding-top: 20px;
                                padding-left: 50px;
                            }

                        }

                    }

                    .fetch-more-reply{
                        font-size: 14px;
                        text-align: center;
                        color: #1DAABA;
                        border-top: 1px solid #D6D6D6;
                        cursor: pointer;
                        padding-top: 5px;
                        user-select: none;
                    }

                }
            }

        }
    }

</style>

<style lang="less">

    .content-table-box {

        .table-row {

            .comment-section {

                i.el-icon-chat-line-round {
                    color: #1DAABA;
                    font-size: 14px;
                    padding-right: 5px;
                }

            }

            .reply-section {

                input::placeholder {
                    color: #AEACAC;
                }

                .el-input__inner {
                    height: 32px;
                    border-left: none;
                    padding: 0;
                }

                .el-input__inner:focus,
                .el-input__inner:hover {
                    border-color: #DCDFE6;
                }

                .el-input-group__prepend {
                    padding: 0 10px;
                    background-color: #FFF;
                    border-right: none;
                    color: #AEACAC;
                }
            }

        }
    }

</style>
